import React, { useContext, useEffect, useState } from 'react'
import { useRef } from 'react'
import PageContext from '../../pages/context'
import QuestionUI from './ArticleQuestionUI'
import '../WeekQuiz.scss'
import { scrollToElement } from '../../util/scrollutil'

function SelectButton({ Q, active, handleChangeCurrent }) {
  return (
    <div
      className={active ? 'SelectButton Active' : 'SelectButton'}
      onClick={(e) => handleChangeCurrent(Q)}
    ></div>
  )
}

function Pager({ current, questions, handleChangeCurrent, isAnswerState }) {
  return questions.length <= 1 ? null : (
    <div className={'page-numbers' + (isAnswerState ? '' : ' active')}>
      <div className="current">
        {current.substring(1)} of {questions.length}
      </div>
      <div className="buttons">
        {questions.map((Q) => (
          <SelectButton
            key={Q.id}
            active={Q.id === current}
            Q={Q}
            handleChangeCurrent={handleChangeCurrent}
          />
        ))}
      </div>
    </div>
  )
}

export default function WeekQuiz({ quiz, responseId }) {
  const { questions, title, id, answerDetail } = quiz
  const [currentQuestionId, setCurrentQuestionId] = useState(questions[0].id)
  const [isAnswerState, setIsAnswerState] = useState(true)
  const [defaultHeight, setDefaultHeight] = useState(0)
  const holderRef = useRef(null)
  const [respId, setRespId] = useState(null)

  const handleChangeCurrent = (Q) => {
    setCurrentQuestionId(Q.id)
  }

  useEffect(() => {
    if (responseId) setRespId(responseId)
    let elHeight = holderRef.current.offsetHeight
    elHeight += parseInt(
      window.getComputedStyle(holderRef.current).getPropertyValue('margin-top'),
    )
    elHeight += parseInt(
      window
        .getComputedStyle(holderRef.current)
        .getPropertyValue('margin-bottom'),
    )

    console.log(id, Math.ceil(elHeight))
    setDefaultHeight(Math.ceil(elHeight))
  }, [])

  const goNextQuestion = (index, qid) => () => {
    setRespId(null)
    if (index + 1 < questions.length) {
      setCurrentQuestionId(questions[index + 1].id)
      const elem = document.querySelector('#quiz-' + qid)
      if (elem) {
        scrollToElement(elem)
      }
      return
    }
  }

  return (
    <div
      className="WeekQuiz"
      id={`quiz-${id}`}
      ref={holderRef}
      data-layer-region={title}
      aria-live="polite"
      role="group"
      aria-labelledby={title}
      tabIndex="0"
    >
      {/* <h3>{title}</h3> */}
      {questions.map((Q, index) => (
        <QuestionUI
          key={Q.id}
          Q={Q}
          quiz={quiz}
          answerDetail={answerDetail}
          visible={Q.id === currentQuestionId}
          setIsAnswerState={setIsAnswerState}
          qIndex={index}
          responseId={Q.id === currentQuestionId && respId}
          goNextQuestion={goNextQuestion(index, id)}
          answerState={isAnswerState}
          showNextQuestion={index < questions.length - 1}
        />
      ))}
      {isAnswerState && (
        <Pager
          current={currentQuestionId}
          questions={questions}
          handleChangeCurrent={handleChangeCurrent}
          isAnswerState={isAnswerState}
        />
      )}
    </div>
  )
}